import styled from 'styled-components';
import Box from '../Box/Box';

interface StackProps {
    space: string;
}

const Stack = styled(Box)<StackProps>`
    > * {
        margin-top: ${({ space }) => space};
        margin-bottom: ${({ space }) => space};

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export default Stack;
